import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { ref, reactive } from 'vue'
import PerfectScrollbar from 'perfect-scrollbar';
import Swal from 'sweetalert2'
import { closeModal, openModal, hideModal, centToDollar, formatDate } from '../utilities/_helpers'
import { useUserStore } from './UserStore.js'
import { useSettingStore } from './SettingStore.js'
import { fix } from 'mathjs'

export const useChatStore = defineStore('ChatStore', {
    state: () => {
        return {
            chats: reactive({
                isLoading: false,
                title: null,
                data: []
            }),
            conversations: reactive({
                isLoading: false,
                data: []
            }),
            activeChat: reactive({}),
            route: useRoute(),
            router: useRouter(),
            message: ref(null),
            psChat: ref(null),
            psConversation: ref(null),
            sendButtonKey: ref(1),
            updateChatModalId: 'update-chat-modal',
            title: ref(null),
            openModal: openModal,
            hideModal: hideModal,
            isSending: ref(false),
            userStore: useUserStore(),
            settingStore: useSettingStore(),
            fix: fix,
        }
    },
    actions: {
        fetchChats(url, isSearch = false) {
            const $this = this;
            $this.chats.isLoading = true;
            axios.get(url, {
                params: {
                    title: $this.chats.title
                }
            })
            .then(function (response) {
                if (isSearch) {
                    $this.chats.data = response.data.data.data;
                }
                else {
                    $this.chats.data.push(...response.data.data.data);
                }
                $this.chats.next_page_url = response.data.data.next_page_url;
                $this.chats.isLoading = false;
                $this.psChat.update();
            });
        },
        conversation(url = null) {
            const $this = this;
            if (_.isNull(url)) {
                const route = $this.router.resolve(
                    {
                        name: 'chat',
                        params: {
                            chat: $this.activeChat.id
                        }
                    }
                );
                url = route.href;
            }
            $this.conversations.isLoading = true;
            axios.get(url)
            .then(function (response) {
                if ($this.conversations.data.length == 0) {
                    $this.conversations = response.data.data;
                    document.getElementById("user-conversation").addEventListener('ps-y-reach-start', function () {
                        if (
                            ($this.conversations.isLoading == false)
                            &&
                            !_.isNull($this.conversations.next_page_url)
                        ) {
                            $this.conversation($this.conversations.next_page_url);
                        }
                    });
                    setTimeout(() => {
                        document.querySelector('.chats .chat:last-child').scrollIntoView();
                    }, 1000);
                }
                else {
                    $this.conversations.data.unshift(...response.data.data.data);
                    setTimeout(() => {
                        document.querySelector('.chats .chat:nth-child(9)').scrollIntoView();
                    }, 1000);
                }
                $this.conversations.next_page_url = response.data.data.next_page_url;
                $this.conversations.isLoading = false;
                $this.psConversation.update();
            });
        },
        deleteChat(chat) {
            let $this = this;
            Object.assign($this.activeChat, chat);
            const route = $this.router.resolve(
                {
                    name: 'chat',
                    params: { chat: $this.activeChat.id }
                }
            );
            Swal.fire({
                title: 'Are you sure you want to delete Chat?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    axios.delete(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        _.remove($this.chats.data, { id: response.data.data.id });
                        $this.activeChat.length = 0;
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        sendMessage(message) {
            const $this = this;
            let route = $this.router.resolve(
                {
                    name: 'chat-send-message',
                    params: {
                        chat: $this.activeChat.id
                    }
                }
            );
            if ($this.activeChat.id == true) {
                route = $this.router.resolve(
                    {
                        name: 'chat-create',
                    }
                );
            }
            $this.conversations.data.push({
                "message": $this.message,
                "sender_id": $this.userStore.user.id
            });
            setTimeout(() => {
                document.querySelector('.chats .chat:last-child').scrollIntoView();
            }, 1000);
            $this.isSending = true;
            axios.post(route.href, { message: $this.message })
            .then(function (response) {
                $this.isSending = false;
                $this.sendButtonKey++;
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.message = null;
                $this.userStore.user.balance = fix(response.data.data.balance, $this.settingStore.payment.precision);
                $this.conversations.data.push(response.data.data.conversation);
                if ($this.activeChat.id == true) {
                    $this.chats.data.unshift(response.data.data.chat);
                    Object.assign($this.activeChat, response.data.data.chat);
                }
                setTimeout(() => {
                    document.querySelector('.chats .chat:last-child').scrollIntoView();
                }, 1000);
                // $this.conversation($this.activeChat);
            });
        },
        editChat() {
            this.openModal(`#${this.updateChatModalId}`);
            this.title = this.activeChat.title;
        },
        newConversation() {
            this.activeChat.id = true;
            this.activeChat.title = null;
            this.conversations.data.length = 0;
        },
        updateChat() {
            const $this = this,
            route = $this.router.resolve(
                {
                    name: 'chat-update',
                    params: {
                        chat: this.activeChat.id
                    }
                }
            );
            axios.put(
                route.href,
                {
                    title: $this.title
                }
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                _.each($this.chats.data, function (chat){
                    if (chat.id == response.data.data.id) {
                        chat.title = response.data.data.title;
                        chat.created_at = response.data.data.created_at;
                    }
                });
                $this.activeChat.title = $this.title;
                $this.hideModal(`#${$this.updateChatModalId}`);
                toastr.success(response.data.message, 'Success!');
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        }
    },
    getters: {
    },
})
